import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
    type RouteableIntent,
    type PaginationIntent,
} from '@jet-app/music-classical/intents';

export interface LibraryPlaylistPageIntent extends RouteableIntent {
    $kind: IntentKind.LIBRARY_PLAYLIST_PAGE;
    id: string;
}

export const isLibraryPlaylistPageIntent =
    makeIntentGuard<LibraryPlaylistPageIntent>(
        IntentKind.LIBRARY_PLAYLIST_PAGE,
    );

export const makeLibraryPlaylistPageIntent =
    makeIntentBuilderFunction<LibraryPlaylistPageIntent>(
        IntentKind.LIBRARY_PLAYLIST_PAGE,
    );

export const makePlaylistPaginationIntent =
    makeIntentBuilderFunction<PaginationIntent>(
        IntentKind.LIBRARY_PLAYLIST_PAGINATION,
    );
